import React, { useState } from 'react';
import { Layout, theme } from 'antd';
import { Navigate, Outlet } from 'react-router-dom';
import AppHeader from '../AppHeader/AppHeader';
import { authService } from '../../services/api';
import SideMenu from './SideMenu';
import { PageTitleProvider } from '../../context/PageTitleContext';

const { Content } = Layout;

// Внутренний компонент, который использует контекст
const MainLayoutInner = () => {
    const [collapsed, setCollapsed] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Отслеживание изменения размера экрана
    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Функция для обработки сворачивания меню
    const handleCollapse = (isCollapsed) => {
        setCollapsed(isCollapsed);
    };

    // Рассчитываем отступ для основного контента в зависимости от состояния меню
    const getMarginLeft = () => {
        if (isMobile) return 0;
        return collapsed ? 80 : 260;
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <AppHeader />

            <Layout style={{ marginTop: 64 }}>
                <SideMenu onCollapse={handleCollapse} />

                <Layout
                    style={{
                        marginLeft: getMarginLeft(),
                        padding: '24px',
                        transition: 'margin-left 0.2s'
                    }}
                >
                    <Content
                        style={{
                            margin: 0,
                            minHeight: 'calc(100vh - 112px)',
                        }}
                    >
                        <Outlet />
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
};

// Основной компонент с проверкой аутентификации и провайдером контекста
const MainLayout = () => {
    if (!authService.isAuthenticated()) {
        return <Navigate to="/login" />;
    }

    return (
        <PageTitleProvider>
            <MainLayoutInner />
        </PageTitleProvider>
    );
};

export default MainLayout;